
import { AvatarScreenNavigationProps } from "./types"
import React from "react"
import Avatar from "./avatar-screen"
import { PageRoot } from "~screens/page-root"
import { CenterFlex } from "~components/El"


const AvatarScreen: React.FC<AvatarScreenNavigationProps> = () => {
  return (
    <PageRoot>
      <CenterFlex height={'auto'}>
      <Avatar />
      </CenterFlex>
    </PageRoot>
  )
}

export default AvatarScreen
